import { render, staticRenderFns } from "./NewTicketReport.vue?vue&type=template&id=dc97cbb4"
import script from "./NewTicketReport.vue?vue&type=script&lang=js"
export * from "./NewTicketReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports